import {
  getTopRetailers,
  groupRetailers,
  MIN_RETAILER_COUNT,
} from './retailers';

type MinimalCpgRetailer = Parameters<typeof groupRetailers>[0][number] &
  Parameters<typeof getTopRetailers>[0][number];

export const getSummaryRetailers = <T extends MinimalCpgRetailer>(
  retailers: T[],
  filterOther?: boolean
) => {
  const groupedRetailers = groupRetailers(retailers);
  const topRetailers = getTopRetailers(groupedRetailers.topRetailers).slice(
    0,
    MIN_RETAILER_COUNT
  );

  return filterOther
    ? topRetailers
    : [
        ...topRetailers,
        ...(groupedRetailers.otherRetailer
          ? [groupedRetailers.otherRetailer]
          : []),
      ];
};
